import React from "react"

import style from "./DiscountedCartProgressBar.module.scss"

// ----------------------------------------------------------------------------

function DiscountedCartProgressBar(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { cartSubtotal, minimumAmountCents, discountPercentage } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let percentage = (cartSubtotal * 100) / minimumAmountCents

  let bsStyle = style.warning
  if (percentage >= 100) {
    bsStyle = style.success
    percentage = 100
  }

  // -------------------------------------

  return (
    <div className={style.container}>
      <div className={style.descContainer}>
        <i className={`fal fa-badge-percent mt-1 mr-3 ${style.icon}`}></i>
        <span>
          {I18n.t("service_ordering.reach_promo_min_amount", {
            min_amount: minimumAmountCents / 100,
            percentage: discountPercentage
          })}
        </span>
      </div>
      <div className={style.progressContainer}>
        <div
          className={`${style.progressInner} ${bsStyle}`}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default DiscountedCartProgressBar
